import { AlignCenter } from '../../utils/editorReactIcons';
export { AlignCenter };
export default AlignCenter;
